// Généré par scripts/generate-flipt-types.js — NE PAS ÉDITER. Relancer : yarn flipt:types
export const FLAGS = {
  CAForecasting: 'CA-forecasting',
  absenceShift: 'absence-shift',
  creneauEndsMidnight: 'creneau-ends-midnight',
  dashboardRh: 'dashboard-rh',
  dashboardRhModalEffectifTotal: 'dashboard-rh-modal-effectif-total',
  exportFicheCollab: 'export-fiche-collab',
  featureFlags: 'feature-flags',
  hrExportAttendanceMultiStore: 'hr-export-attendance-multi-store',
  hrExportPlanningMultiStore: 'hr-export-planning-multi-store',
  permissionV2: 'permission-v2',
  planningRemainingHoursMenu: 'planning-remaining-hours-menu',
  restartCameraServer: 'restart-camera-server',
  visioReviews: 'visio-reviews',
} as const

export type FlagKey = (typeof FLAGS)[keyof typeof FLAGS]

export interface FliptVariants {
  'CA-forecasting': never // flag booléen
  'absence-shift': never // flag booléen
  'creneau-ends-midnight': never // flag booléen
  'dashboard-rh': never // flag booléen
  'dashboard-rh-modal-effectif-total': never // flag booléen
  'export-fiche-collab': never // flag booléen
  'feature-flags': never // flag booléen
  'hr-export-attendance-multi-store': never // flag booléen
  'hr-export-planning-multi-store': never // flag booléen
  'permission-v2': never // flag booléen
  'planning-remaining-hours-menu': never // flag booléen
  'restart-camera-server': never // flag booléen
  'visio-reviews': never // flag booléen
}
